
<style scoped>
    .p-t {
        margin-bottom: 0px !important;
    }
</style>
<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <span
        v-show="!showIcon"
        v-bind="attrs"
        v-on="on"
      >
        <slot />
      </span>
      <v-icon
        v-show="showIcon"
        style="margin-bottom: 3px;"
        color="primary"
        dark
        :size="size"
        v-bind="attrs"
        v-on="on"
      >
        mdi-help-circle
      </v-icon>
    </template>
    <span sytle="z-index:30">
      <p
        v-for="(i,index) in dis_arr"
        :key="index"
        class="p-t"
      >{{ i }}</p>
     
    </span>
  </v-tooltip>
</template>
<script>
  export default {
    props: {
      title: {
        type:[String, Array]
      },
      showIcon: {
        type: Boolean,
        default:() => true
      },
      size: {
        type:Number,
        default: 18
      }
    },
    computed: {
      dis_arr() {
        
        return typeof this.title === 'string' ? [this.title] : this.title
      }
    }
  }
</script>
